export const getViewModeList = (itemsPerSet = 4) => [
  { value: 'varyingProbability', text: `Preference Likelihood (${itemsPerSet}/screen)` },
  { value: 'probability', text: 'Average-based PL (50% baseline)' },
  { value: 'raw', text: 'Utility Scores' }
]

export const getYAxisTitle = (viewMode, itemsPerSet) =>
  getViewModeList(itemsPerSet).find(v => v.value === viewMode)?.text
